<template>
    <div >
    <Navigation/>
    <div class="section__container">
    <h1 class="">Témoignages de nos clients</h1>

     <div class="powr-product-reviews" id="303ce82b_1656225690"></div>
  
    </div>
    <Footer/>

    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
    export default {
        components:{
            Navigation,
            Footer
        }
    }
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

@media(min-width:60rem){
   .section__container{
    position: relative;
    margin-top: 13rem;
    
   }

}
</style>